import {
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Divider,
    FormControlLabel,
    Grid,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive"
import PeopleIcon from "@material-ui/icons/People"
import SendIcon from "@material-ui/icons/Send"
import { useSnackbar } from "../../../utils/notificacoes"
import React, { useCallback, useEffect, useState } from "react"
import {
    calcularAlcance,
    enviarNotificacao,
    isErroApi,
    obterHistorico,
    obterInscritos,
    type AlcanceResposta,
    type FiltroSegmentacao,
    type HistoricoItem,
    type TipoPedido,
} from "../../../services/notificacaoPush"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "960px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    titleText: {
        fontWeight: 700,
        color: "#2c3e50",
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down("sm")]: { fontSize: "1.3rem" },
    },
    inscritosCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "#fff",
        padding: theme.spacing(2.5),
        marginBottom: theme.spacing(3),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    inscritosIcon: {
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        borderRadius: "50%",
        width: 56,
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inscritosNumero: {
        fontWeight: 700,
        color: "#2c3e50",
        lineHeight: 1,
    },
    card: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "#fff",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
    },
    cardContent: { padding: theme.spacing(2.5) },
    secaoTitulo: {
        fontWeight: 600,
        color: "#2c3e50",
        marginBottom: theme.spacing(1.5),
        fontSize: "0.95rem",
    },
    botaoPrimario: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "#fff",
        fontWeight: 600,
        "&:hover": { backgroundColor: "#388e3c" },
    },
    botaoSecundario: {
        borderRadius: 25,
        borderColor: "#4caf50",
        color: "#4caf50",
        fontWeight: 600,
        "&:hover": { backgroundColor: "#e8f5e9" },
    },
    alcanceBox: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: 12,
        backgroundColor: "#e3f2fd",
        border: "1px solid #bbdefb",
    },
    alcanceNumero: {
        fontWeight: 700,
        color: "#1565c0",
    },
    resultadoBox: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: 12,
        backgroundColor: "#e8f5e9",
        border: "1px solid #c8e6c9",
    },
    aviso: {
        color: "#7f8c8d",
        fontSize: "0.82rem",
        lineHeight: 1.6,
    },
    tabs: {
        marginBottom: theme.spacing(2),
    },
}))

const TIPOS_PEDIDO: { valor: TipoPedido; label: string }[] = [
    { valor: 0, label: "Delivery" },
    { valor: 1, label: "Retirada" },
    { valor: 2, label: "Mesa" },
]

type FiltroForm = {
    recenciaModo: "" | "INATIVOS" | "ATIVOS"
    recenciaDias: string
    minPedidos: string
    dataInicio: string
    dataFim: string
    tiposPedido: TipoPedido[]
}

const FILTRO_INICIAL: FiltroForm = {
    recenciaModo: "",
    recenciaDias: "",
    minPedidos: "",
    dataInicio: "",
    dataFim: "",
    tiposPedido: [],
}

function montarFiltro(form: FiltroForm): FiltroSegmentacao {
    const filtro: FiltroSegmentacao = {}
    if (form.recenciaModo) {
        filtro.recenciaModo = form.recenciaModo
        const dias = parseInt(form.recenciaDias, 10)
        if (dias > 0) filtro.recenciaDias = dias
    }
    const minPedidos = parseInt(form.minPedidos, 10)
    if (minPedidos > 0) filtro.minPedidos = minPedidos
    if (form.dataInicio) filtro.dataInicio = form.dataInicio
    if (form.dataFim) filtro.dataFim = form.dataFim
    if (form.tiposPedido.length > 0) filtro.tiposPedido = [...form.tiposPedido].sort()
    return filtro
}

export function NotificacaoPushComponent() {
    const classes = useStyles()
    const { enqueueSnackbar } = useSnackbar()

    const autorizacao = localStorage.getItem("chaveSistema") || ""

    const [aba, setAba] = useState(0)

    const [inscritos, setInscritos] = useState<number | null>(null)
    const [carregandoInscritos, setCarregandoInscritos] = useState(false)

    const [filtro, setFiltro] = useState<FiltroForm>(FILTRO_INICIAL)
    const [alcance, setAlcance] = useState<AlcanceResposta | null>(null)
    const [calculandoAlcance, setCalculandoAlcance] = useState(false)

    const [titulo, setTitulo] = useState("")
    const [mensagem, setMensagem] = useState("")
    const [enviando, setEnviando] = useState(false)
    const [resultadoEnvio, setResultadoEnvio] = useState<string | null>(null)

    const [historico, setHistorico] = useState<HistoricoItem[]>([])
    const [carregandoHistorico, setCarregandoHistorico] = useState(false)
    const [histInicio, setHistInicio] = useState("")
    const [histFim, setHistFim] = useState("")

    const alertStart = useCallback(
        (msg: string, tipo: "success" | "error" | "info") => {
            enqueueSnackbar(msg, { variant: tipo })
        },
        [enqueueSnackbar]
    )

    const carregarInscritos = useCallback(async () => {
        if (!autorizacao) return
        setCarregandoInscritos(true)
        const resposta = await obterInscritos(autorizacao)
        setCarregandoInscritos(false)
        if (isErroApi(resposta)) {
            alertStart(resposta.erro, "error")
            return
        }
        setInscritos(resposta.quantidadeInscritos)
    }, [autorizacao, alertStart])

    const carregarHistorico = useCallback(async () => {
        if (!autorizacao) return
        setCarregandoHistorico(true)
        const resposta = await obterHistorico(autorizacao, {
            dataInicio: histInicio || undefined,
            dataFim: histFim || undefined,
        })
        setCarregandoHistorico(false)
        if (isErroApi(resposta)) {
            alertStart(resposta.erro, "error")
            return
        }
        setHistorico(resposta)
    }, [autorizacao, alertStart, histInicio, histFim])

    useEffect(() => {
        carregarInscritos()
        carregarHistorico()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function alternarTipoPedido(valor: TipoPedido) {
        setFiltro(prev => ({
            ...prev,
            tiposPedido: prev.tiposPedido.includes(valor)
                ? prev.tiposPedido.filter(t => t !== valor)
                : [...prev.tiposPedido, valor],
        }))
        setAlcance(null)
    }

    function atualizarFiltro<K extends keyof FiltroForm>(campo: K, valor: FiltroForm[K]) {
        setFiltro(prev => ({ ...prev, [campo]: valor }))
        setAlcance(null)
    }

    async function handleCalcularAlcance() {
        if (!autorizacao) return
        setCalculandoAlcance(true)
        const resposta = await calcularAlcance(autorizacao, montarFiltro(filtro))
        setCalculandoAlcance(false)
        if (isErroApi(resposta)) {
            alertStart(resposta.erro, "error")
            return
        }
        setAlcance(resposta)
    }

    async function handleEnviar() {
        if (!autorizacao) return
        if (!titulo.trim() || !mensagem.trim()) {
            alertStart("Informe título e mensagem antes de enviar.", "error")
            return
        }
        setEnviando(true)
        setResultadoEnvio(null)
        const resposta = await enviarNotificacao(autorizacao, {
            titulo: titulo.trim(),
            mensagem: mensagem.trim(),
            filtro: montarFiltro(filtro),
        })
        setEnviando(false)
        if (isErroApi(resposta)) {
            alertStart(resposta.erro, "error")
            return
        }
        setResultadoEnvio(resposta.mensagem)
        alertStart(`Enviada para ${resposta.enviados} inscrito(s).`, "success")
        setTitulo("")
        setMensagem("")
        setAlcance(null)
        carregarHistorico()
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                <Typography variant="h5" className={classes.titleText}>
                    Notificação Push
                </Typography>
                <Typography className={classes.aviso} style={{ marginBottom: 20 }}>
                    Envie notificações Web Push para os clientes da loja em uso que aceitaram
                    receber avisos no navegador. Segmente por recência, quantidade de pedidos, tipo
                    e período.
                </Typography>

                <Paper className={classes.inscritosCard} elevation={0}>
                    <Box className={classes.inscritosIcon}>
                        <PeopleIcon fontSize="large" />
                    </Box>
                    <Box>
                        {carregandoInscritos ? (
                            <CircularProgress size={24} />
                        ) : (
                            <Typography variant="h4" className={classes.inscritosNumero}>
                                {inscritos != null ? inscritos.toLocaleString("pt-BR") : "—"}
                            </Typography>
                        )}
                        <Typography className={classes.aviso}>clientes inscritos ativos</Typography>
                    </Box>
                </Paper>

                <Tabs
                    className={classes.tabs}
                    value={aba}
                    onChange={(_, v) => setAba(v)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Disparar" />
                    <Tab label="Histórico" />
                </Tabs>

                {aba === 0 && (
                    <Paper className={classes.card}>
                        <Box className={classes.cardHeader}>
                            <Typography variant="h6" className={classes.cardHeaderTitle}>
                                <NotificationsActiveIcon
                                    fontSize="small"
                                    style={{ verticalAlign: "middle", marginRight: 8 }}
                                />
                                Nova notificação
                            </Typography>
                        </Box>
                        <Box className={classes.cardContent}>
                            <Typography className={classes.secaoTitulo}>Mensagem</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label="Título"
                                        value={titulo}
                                        onChange={e => setTitulo(e.target.value)}
                                        inputProps={{ maxLength: 120 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        variant="outlined"
                                        size="small"
                                        label="Mensagem"
                                        value={mensagem}
                                        onChange={e => setMensagem(e.target.value)}
                                        inputProps={{ maxLength: 300 }}
                                    />
                                </Grid>
                            </Grid>

                            <Divider style={{ margin: "24px 0" }} />

                            <Typography className={classes.secaoTitulo}>
                                Segmentação (opcional)
                            </Typography>
                            <Typography className={classes.aviso} style={{ marginBottom: 16 }}>
                                Sem filtros, a notificação vai para todos os inscritos ativos. Com
                                qualquer filtro, só entram clientes que já fizeram pedido.
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label="Recência"
                                        value={filtro.recenciaModo}
                                        onChange={e =>
                                            atualizarFiltro(
                                                "recenciaModo",
                                                e.target.value as FiltroForm["recenciaModo"]
                                            )
                                        }
                                    >
                                        <MenuItem value="">Não filtrar por recência</MenuItem>
                                        <MenuItem value="INATIVOS">
                                            Inativos (sem comprar há X dias)
                                        </MenuItem>
                                        <MenuItem value="ATIVOS">
                                            Ativos (compraram nos últimos X dias)
                                        </MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        size="small"
                                        label="Dias de recência"
                                        value={filtro.recenciaDias}
                                        onChange={e =>
                                            atualizarFiltro("recenciaDias", e.target.value)
                                        }
                                        disabled={!filtro.recenciaModo}
                                        inputProps={{ min: 1 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        size="small"
                                        label="Mínimo de pedidos"
                                        value={filtro.minPedidos}
                                        onChange={e => atualizarFiltro("minPedidos", e.target.value)}
                                        inputProps={{ min: 1 }}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        label="Pedido de"
                                        InputLabelProps={{ shrink: true }}
                                        value={filtro.dataInicio}
                                        onChange={e => atualizarFiltro("dataInicio", e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        label="Pedido até"
                                        InputLabelProps={{ shrink: true }}
                                        value={filtro.dataFim}
                                        onChange={e => atualizarFiltro("dataFim", e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        className={classes.aviso}
                                        style={{ marginBottom: 4 }}
                                    >
                                        Tipos de pedido
                                    </Typography>
                                    <Box display="flex" flexWrap="wrap">
                                        {TIPOS_PEDIDO.map(tipo => (
                                            <FormControlLabel
                                                key={tipo.valor}
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={filtro.tiposPedido.includes(
                                                            tipo.valor
                                                        )}
                                                        onChange={() =>
                                                            alternarTipoPedido(tipo.valor)
                                                        }
                                                    />
                                                }
                                                label={tipo.label}
                                            />
                                        ))}
                                    </Box>
                                </Grid>
                            </Grid>

                            <Box
                                mt={2}
                                display="flex"
                                alignItems="center"
                                style={{ gap: 12, flexWrap: "wrap" }}
                            >
                                <Button
                                    variant="outlined"
                                    className={classes.botaoSecundario}
                                    onClick={handleCalcularAlcance}
                                    disabled={calculandoAlcance}
                                >
                                    {calculandoAlcance ? "Calculando..." : "Calcular alcance"}
                                </Button>
                            </Box>

                            {alcance && (
                                <Box className={classes.alcanceBox}>
                                    <Typography variant="h6" className={classes.alcanceNumero}>
                                        {alcance.alcance.toLocaleString("pt-BR")} inscrito(s) no
                                        alcance
                                    </Typography>
                                    <Typography className={classes.aviso}>
                                        {alcance.filtroVazio
                                            ? "Todos os inscritos ativos."
                                            : alcance.descricaoFiltros}
                                    </Typography>
                                </Box>
                            )}

                            <Divider style={{ margin: "24px 0" }} />

                            <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                                <Button
                                    variant="contained"
                                    className={classes.botaoPrimario}
                                    startIcon={
                                        enviando ? (
                                            <CircularProgress size={18} color="inherit" />
                                        ) : (
                                            <SendIcon />
                                        )
                                    }
                                    onClick={handleEnviar}
                                    disabled={enviando}
                                >
                                    {enviando ? "Enviando..." : "Enviar notificação"}
                                </Button>
                                {enviando && (
                                    <Typography className={classes.aviso}>
                                        O envio é síncrono e pode demorar. Não feche a página.
                                    </Typography>
                                )}
                            </Box>

                            {resultadoEnvio && (
                                <Box className={classes.resultadoBox}>
                                    <Typography style={{ color: "#2e7d32", fontWeight: 600 }}>
                                        {resultadoEnvio}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                )}

                {aba === 1 && (
                    <Paper className={classes.card}>
                        <Box className={classes.cardHeader}>
                            <Typography variant="h6" className={classes.cardHeaderTitle}>
                                Histórico de disparos
                            </Typography>
                        </Box>
                        <Box className={classes.cardContent}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        label="De"
                                        InputLabelProps={{ shrink: true }}
                                        value={histInicio}
                                        onChange={e => setHistInicio(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        label="Até"
                                        InputLabelProps={{ shrink: true }}
                                        value={histFim}
                                        onChange={e => setHistFim(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Button
                                        variant="outlined"
                                        className={classes.botaoSecundario}
                                        onClick={carregarHistorico}
                                        disabled={carregandoHistorico}
                                    >
                                        {carregandoHistorico ? "Buscando..." : "Filtrar"}
                                    </Button>
                                </Grid>
                            </Grid>

                            <TableContainer style={{ marginTop: 16, overflowX: "auto" }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Data</TableCell>
                                            <TableCell>Título</TableCell>
                                            <TableCell>Mensagem</TableCell>
                                            <TableCell>Segmentação</TableCell>
                                            <TableCell align="center">Alvo</TableCell>
                                            <TableCell align="center">Enviados</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {historico.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={6}
                                                    align="center"
                                                    style={{ color: "#7f8c8d" }}
                                                >
                                                    {carregandoHistorico
                                                        ? "Carregando..."
                                                        : "Nenhum disparo encontrado."}
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {historico.map(item => (
                                            <TableRow key={item.id} hover>
                                                <TableCell style={{ whiteSpace: "nowrap" }}>
                                                    {item.dataEnvio}
                                                </TableCell>
                                                <TableCell>
                                                    <strong>{item.titulo}</strong>
                                                </TableCell>
                                                <TableCell>{item.mensagem}</TableCell>
                                                <TableCell>
                                                    <Chip
                                                        size="small"
                                                        label={
                                                            item.descricaoFiltros || "Todos"
                                                        }
                                                        style={{
                                                            backgroundColor: "#e8f5e9",
                                                            color: "#2e7d32",
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    {item.quantidadeAlvo}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <strong>{item.quantidadeEnviados}</strong>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Paper>
                )}
            </Box>
        </Box>
    )
}
